var _defs, _rect, _path, _polygon, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _polygon2, _polygon3, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoRtl5Minutes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 745 225.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e00f22;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo_rtl5minutes_RGB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 745,
    height: 225.44,
    rx: 15.87,
    ry: 15.87
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M298.56,91.2A36.4,36.4,0,0,0,291,92V80.92h25.5l11.81-20.44H270.53v51.84l13.68,7.89a16.37,16.37,0,0,1,12.36-8.37v0a16.19,16.19,0,0,1,2-.13,16.39,16.39,0,1,1-14.24,24.47l-10.91,18.89A36.88,36.88,0,1,0,298.56,91.2Z",
    transform: "translate(0)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "337.61 60.48 325.78 80.97 344.6 80.97 356.43 60.48 337.61 60.48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M391.73,144.71V119.44c0-6.82-3.92-12.5-10.73-12.5s-11.1,5.68-11.1,12.5v25.27h-9.6V98.63h8.95l.65,6.16c2.62-5,8-6.9,12.88-6.9,5.87,0,11.84,2.42,14.45,9.23C401,100.31,406.75,98,413,98c12.68,0,19.49,8,19.49,21.27v25.46h-9.7V119.25c0-6.81-3.36-12.22-10.17-12.22s-11.19,5.59-11.19,12.41v25.27Z",
    transform: "translate(0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M455.7,85.2c0,7.93-11.94,7.93-11.94,0S455.7,77.37,455.7,85.2ZM444.88,98.54v46.17h9.61V98.54Z",
    transform: "translate(0)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M502.43,144.71V120.09c0-7.93-4.48-13.24-12.41-13.24-7.65,0-12.87,6.25-12.87,13.8v24.06h-9.61V98.63h8.77l.56,6.72c4.39-4.94,9.52-7.37,15.48-7.37,11.19,0,19.78,7.93,19.78,22v24.72Z",
    transform: "translate(0)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M533.29,98.73v24.62c0,7.84,4.48,13.25,12.5,13.25,7.56,0,12.78-6.25,12.78-13.9v-24h9.61v46.08H559.5l-.56-6.82c-4.48,5.13-9.42,7.47-15.85,7.47-11.29,0-19.4-8.12-19.4-22V98.73Z",
    transform: "translate(0)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M596.06,85.48V98.82h13.43v8.3H596V129c0,4.85,2.15,7.56,6.63,7.56a13.89,13.89,0,0,0,5.87-1.59l2.8,8.21a21.75,21.75,0,0,1-9.23,2.05c-10,.28-15.67-5.41-15.67-16.23V107.12h-8.87v-8.3h8.87V86.51Z",
    transform: "translate(0)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M626.37,125.31c.84,7,6.62,11.56,15,11.56,4.67,0,10.54-1.77,13.34-4.94L661,138c-4.76,5.23-12.68,7.84-19.77,7.84-15.12,0-24.82-9.6-24.82-24.34,0-14,9.8-24,24.16-24,14.83,0,24.9,9,23.14,27.8Zm28.07-8.12c-.56-7.27-5.88-11.09-13.62-11.09-7,0-12.78,3.82-14.27,11.09Z",
    transform: "translate(0)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M702.84,110c-3.63-3.36-7.56-4.29-12.13-4.29-5.87-.09-9.79,1.87-9.79,5.51.1,3.82,4.1,5.32,10,5.87,8.49.75,19.59,2.61,19.5,14.46-.1,8.58-7.65,14.55-19.59,14.55-7.46,0-14.93-1.68-21-8.48l5-6.82c4.29,4.76,10.72,6.72,16.13,6.82,4.57,0,9.71-1.69,9.8-6,.09-4.11-3.83-5.69-10.64-6.35-8.67-.84-18.65-3.64-18.74-13.81s10.53-14,19.11-14c7.1,0,12.6,1.59,17.73,6.16Z",
    transform: "translate(0)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.65,99.86h4c5.75,0,7.1-6.13,7.1-12.12,0-11.61-4.18-12.15-11.05-11.89Zm37.21,60.05H72a12.79,12.79,0,0,1-3.5-7.09c-.34-8.77.1-21.22-.47-27.34s-1.88-10.07-6.6-10.49H57.66v44.92H34.6V60.42H66.1c16.52,0,25.36,5.81,25.36,24.08,0,14.37-4.74,17-13.23,21.54h0c5.64,1.46,12.49,6.27,12.82,13.16.57,7.94-.45,26.39.72,32.74,0,0,1.75,6.31,3.09,8",
    transform: "translate(0)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "87.55 60.41 141.32 60.41 141.32 76.92 125.61 76.92 125.61 159.91 102.83 159.91 102.83 76.92 87.55 76.92 87.55 60.41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "144.08 159.91 144.08 60.41 166.83 60.41 166.83 143.97 190.96 143.97 190.96 159.91 144.08 159.91"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 231.54,
    y: 29.69,
    width: 3.11,
    height: 166.07
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRtl5Minutes);
export default __webpack_public_path__ + "static/media/logo_rtl5minutes.606205ff0e7dc4ade091b03cae2da56f.svg";
export { ForwardRef as ReactComponent };